export function percentage(a: number, b: number) {
    return Math.round((a / b) * 100) / 100;
}

export function percentageWithDecimals(a: number, b: number) {
    return Math.round((a / b) * 10000) / 10000;
}
